import {
    MAP_CHANGE_MUTATION
} from '@/components/search-result/_store/types'
import { isUrls } from '@/router/index.js';
import {
    // SET_BLOCK_ID,
    LISTING_SOURCE_MUTATION,
    SET_LISTING_SOURCE_READY,
    SET_SEARCH_DATA_READY,
    OTHER_URL_QUERY_MUTATION,
    ADD_KEYWORD_MUTATION,
    SET_LISTING_IDS
} from '../md-search/_store/config';
import {
    SELECT_SPLIT,
    selectLabels,
    rangeLabels,
    RANGE_SPLIT,
    CHECKBOX_SPLIT,
    TAG_INPUT_SPLIT,
    setRecentlyPropertyType
} from './_util';
import util from '../../common/util';
import { getQueryWithDecodeKey } from '@/clientEnv';
import { getFilterType } from '../md-search/api';
import {
    fetchSearchConf,
    translateOptions,
    fetchFilterItemOptions,
    fetchCenterAllConditions,
    getDefaultSuggestion
} from './api';
import * as TYPES from './_store/types';
import { sqftToAcre } from '@/common/utils';
import { usePageStore } from '@/store'
// import { mockCenterConditionData } from './mock';

// function setBlockId({ commit, mutationType, id }) {
//     commit(mutationType(SET_BLOCK_ID), id);
// }
function setListingSource(store, listingSource) {
    store[LISTING_SOURCE_MUTATION](listingSource);
    store[SET_LISTING_SOURCE_READY](true);
}
/**
 *  If it is a details page listingIds both take effect
 *  list page if url have crmAlertId parameter （ Represents link from alert） unnecessary listingIds， Without alert parameter needs to use listingIds
 * listingIds field may also be ids
 */
function getListingIds(location) {
    const listingReg = /^\/(sold-)?listing(\/[^detail]*)?$/;
    let listingIds =
        location?.query?.listingIds || location?.query?.ids || null;
    if (!listingIds) {
        return; 
    }
    if (listingReg.test(location.pathname)) {
        if (location.query?.crmAlertId) {
            listingIds = null;
        }
    }
    return listingIds;
}

function isCustomListingSource(listingSource) {
    return /^\d\+/.test(listingSource);
}

export const search = {
    isCustomListing(store) {
        return (
            isCustomListingSource(store.listingSource) &&
            isUrls({ names: ['listing', 'sold-listing'], url: this.pageLocation.pathname })
        );
    },
    noUsePresetFilter(store) {
        return (
            search.isCustomListing.call(this, store) || store.hasConditionOnUrl
        );
    },
    normalizeLocation(keywordType = '', key = '') {
        const keywordTypeArr = keywordType.split(';');
        const keyArr = key.split(';');
        const newKeyArr = keyArr.map((key, index) => {
            return (keywordTypeArr[index] || 'none') + ':' + key;
        });
        return newKeyArr.join(';');
    },
    async processResult(store, fetcherData) {
        // this.fetcherData = data;
        let purchaseIndex = -1;
        let sort = [];
        //  Non-Chinese Taiwan ，currenyPriceKeys Collect all price related fields ， Because it needs to be converted into U.S. dollars and placed in url superior
        let currenyKeys = [];
        if (store.listingSource === 'rental listings' && fetcherData.propertyConfigs) {
            fetcherData.propertyConfigs = fetcherData.propertyConfigs.filter(it => it.businessName !== 'purchaseType')
        }
        //  deal with propertyConfigs
        //  Each configuration item's  kee  put into a sort middle ，config.args= config.value deserialization
        //  Record  purchaseType-For-Sale-Rent  index of
        (fetcherData.propertyConfigs || []).forEach((config, index) => {
            sort.push(config.kee);
            if (config.mask === 'money') {
                currenyKeys.push(config.kee);
            }
            if (config.kee === 'purchaseType-For-Sale-Rent') {
                purchaseIndex = index;
            }
            try {
                if (config.values && !config.args) {
                    config.args = JSON.parse(config.values);
                }
            } catch (e) {
                console.error(e);
            }
        });
        //  deal with  more
        //  same propertyConfigs processing method
        (fetcherData.more || []).forEach(group => {
            group.propertyConfigs.forEach(config => {
                sort.push(config.kee);
                if (config.mask === 'money') {
                    currenyKeys.push(config.kee);
                }
                try {
                    if (config.values && !config.args) {
                        config.args = JSON.parse(config.values);
                    }
                } catch (e) {
                    console.error(e);
                }
            });
        });
        // this.conditionSort = sort;
        if (
            purchaseIndex !== -1 &&
            fetcherData.more?.length > 0 &&
            store.listingSource !== 'rental listings'
        ) {
            const pruchaseConfig = fetcherData.propertyConfigs.splice(
                purchaseIndex,
                1
            )[0];
            for (let i = 0, len = fetcherData.more.length; i < len; i++) {
                const id = fetcherData.more[i].id;
                if (id === 1) {
                    fetcherData.more[i].propertyConfigs.unshift(pruchaseConfig);
                    break;
                }
            }
        }
        store[TYPES.SET_SEARCH_CONFIG]({
            fetcherData,
            conditionSort: sort
        });
        let outsideFields = [];
        let isNotLayout1Mobile = this.platform.isMobile && this.theme !== 'layout1'
        if (!isNotLayout1Mobile) {
            outsideFields = (fetcherData.propertyConfigs || []).map(item => item.kee);
        }
        store[TYPES.CURRENCY_PRICE_KEYS](currenyKeys);
        store[TYPES.SET_OUT_SIDE_FIELDS](outsideFields);
        await search.normalizeUrlParams.call(this, store);
    },
    processLocation(store, query) {
        // URL  Supports two different formats of  LOCATION  field
        // 1. &key=`${keywordType1}:${key1};${keywordType2}:${key2}`;
        // 2. &keywordType=`${keywordType1};${keywordType1}`&key=`${key1}:${key2}`;s
        if (query.keywordType) {
            query.key = search.normalizeLocation.call(this, query.keywordType, query.key);
        }
        if (query.key) {
            store.hasConditionOnUrl = true;
            store.locationQueryOnUrl = {
                key: query.key
            };
        }
        delete query.keywordType;
        delete query.key;
        return query;
    },
    processMapCondition(store, query) {
        const obj = {};
        const keys = ['rect', 'mapPath', 'mapSearch', 'mapRadius'];
        const helper = (query, key) => {
            if (query[key]) {
                if (
                    key === 'mapPath' ||
                    key === 'mapSearch' ||
                    key === 'mapRadius'
                ) {
                    store.hasConditionOnUrl = true;
                }
                obj[key] = query[key];
                delete query[key];
            }
        };
        keys.forEach(k => helper(query, k));
        store.mapConditionOnUrl = obj;
        return query;
    },
    processSearchData(store, query) {
        const conditionSort = store.conditionSort;
        //  plus listingIds Temporary patch   In the later stage, the backend should provide all the search keyword tables ， Instead of filtering at the front end
        const keys = [...conditionSort, 'selected', 'listingIds', 'ids'];
        Object.keys(query).forEach(key => {
            if (keys.includes(key)) {
                store.hasConditionOnUrl = true;
                store.searchQueryOnUrl = {
                    ...(store.searchQueryOnUrl || {}),
                    [key]: query[key]
                };
                delete query[key];
            }
        });
        return query;
    },
    processPresetParams(store, query) {
        if (query.presetParams) {
            store.hasConditionOnUrl = true;
            store.urlPresetParams = util.parseJSON(query.presetParams)
            delete query.presetParams;
        }
        return query;
    },
    async normalizeUrlParams(store) {
        let { page: globalData } = usePageStore(this.$pinia);
        let query = getQueryWithDecodeKey(globalData);
        query = search.processLocation.call(this, store, query);
        query = search.processMapCondition.call(this, store, query);
        query = search.processSearchData.call(this, store, query);
        query = search.processPresetParams.call(this, store, query);
        delete query['chime-format'];
        delete query['global_domain'];
        store[OTHER_URL_QUERY_MUTATION](query);
        search.mergeCondition.call(this, store);
    },
    mergeCondition(store) {
        let { page: globalData } = usePageStore(this.$pinia);
        let params = {};
        const listingIds = getListingIds(this.pageLocation);
        //  The module has no default or url parameter exists listingIds  just use url parameter
        if (
            search.noUsePresetFilter.call(this, store) ||
            listingIds ||
            isCustomListingSource(globalData.URI_REQUEST_PARAMS?.listingSource)
        ) {
            const urlPresetParams = store.urlPresetParams;
            if (urlPresetParams) {
                params = { ...urlPresetParams };
            } else {
                const searchQueryOnUrl = store.searchQueryOnUrl;
                const locationQueryOnUrl = store.locationQueryOnUrl;
                params = {
                    ...(searchQueryOnUrl || {}),
                    ...(locationQueryOnUrl || {}),
                    ...store.mapConditionOnUrl
                };
            }
            if (listingIds) {
                store[SET_LISTING_IDS](listingIds);
            }
        } else {
            const { presetFilters } = this;
            presetFilters &&
                presetFilters.forEach(filter => {
                    if (filter && Array.isArray(filter.values)) {
                        params[filter.dn] = filter.values.join(
                            filter.split || ','
                        );
                        if (filter.dn === 'mapSearch' && filter.rect) {
                            params.rect = filter.rect
                        }
                    }
                });
        }
        search.initialCondition.call(this, store, params);
    },
    initialCondition(store, params = {}) {
        const ret = {};
        const checkboxKeys = [];
        const checkboxVal = (params.selected || '').split(CHECKBOX_SPLIT);
        const moduleMap = store.moduleMap;
        Object.keys(moduleMap).forEach(kee => {
            let config = moduleMap[kee];
            if (config.type === 1) {
                if (checkboxVal.includes(kee)) {
                    checkboxKeys.push(kee);
                }
            } else {
                let value = params[kee];
                if (value) {
                    if (kee === 'Property-Type' && !util.isSSRServer) {
                        setRecentlyPropertyType(value);
                    }
                    ret[kee] = search.generateCondition.call(this, store, {
                        config,
                        kee,
                        value
                    });
                }
            }
        });
        let selected = search.generateCheckboxCondition.call(this, {
            keys: checkboxKeys,
            moduleMap: moduleMap
        });
        if (selected.value) {
            ret.selected = search.generateCheckboxCondition.call(this, {
                keys: checkboxKeys,
                moduleMap: moduleMap
            });
        }

        search.initCondition.call(this, store, { ret, params });
    },
    isInMore({ kee, store }) {
        const outsideFields = store.outsideFields;
        return !outsideFields.includes(kee);
    },
    generateCondition(store, { config, kee, value }) {
        let { currency } = usePageStore(this.$pinia);
        switch (config.type) {
        case 1:
            break;
        case 2:
            return {
                kee,
                value,
                labels: rangeLabels(config, value, {
                    currencySymbol: currency.symbol
                }),
                type: 'range',
                split: RANGE_SPLIT,
                inMore: search.isInMore({ kee, store })
            };
        case 3:
        case 4:
            return {
                kee,
                value,
                labels: selectLabels(config, value),
                type: 'select',
                multiple: config.type === 4,
                split: SELECT_SPLIT,
                inMore: search.isInMore({ kee, store })
            };
        case 8: {
            let labels = value ? ['keyword: ' + value] : [];
            return {
                kee,
                value,
                labels: labels,
                type: 'tag-input',
                inMore: search.isInMore({ kee, store }),
                split: TAG_INPUT_SPLIT
            };
        }
        default:
            break;
        }
    },
    generateCheckboxCondition({ keys, moduleMap }) {
        const labels = [];
        keys.forEach(k => {
            labels.push(moduleMap[k].label);
        });
        return {
            kee: 'selected',
            value: keys.join(','),
            labels: labels,
            inMore: true
        };
    },
    initLocation(store, params = {}) {
        if (params.key) {
            params.key.split(';').forEach(key => {
                let arr = key.split(':');
                store[ADD_KEYWORD_MUTATION]({
                    keyword: arr.slice(1).join(':'),
                    keywordType: arr[0]
                });
            });
        }
        if (params.mapPath) {
            store[MAP_CHANGE_MUTATION]({
                mapPath: params.mapPath || ''
            });
        }
        if (params.mapRadius) {
            store[MAP_CHANGE_MUTATION]({
                mapRadius: params.mapRadius || ''
            });
        }
        if (params.mapSearch === 'true' || params.mapSearch === true) {
            store[MAP_CHANGE_MUTATION]({
                mapSearch: true,
                rect: params.rect
            });
        }
    },
    initCondition(store, { ret, params }) {
        let options = [];
        for (let key in ret) {
            let labels = ret[key].labels || [];
            options = options.concat(
                labels.map(label => ({ label, key: key }))
            );
        }
        if (options.length > 0) {
            translateOptions.call(this, options).then(data => {
                for (let key in ret) {
                    ret[key].labels = [];
                }
                data.forEach(item => {
                    ret[item.key].labels.push(item.label);
                });
                store[TYPES.INITIAL_CONDITION](ret);
            });
        }
        store[TYPES.INITIAL_CONDITION](ret);

        // this.initConditionMutation(ret);
        const paramsTemp = {
            rect: params.rect,
            mapPath: params.mapPath,
            mapSearch: params.mapSearch,
            key: params.key,
            mapRadius: params.mapRadius
        };
        search.initLocation.call(this, store, paramsTemp);
    }
};

export const searchCenter = {
    isCustomListing(store) {
        return (
            isCustomListingSource(store.listingSource) &&
            isUrls({ names: ['listing', 'sold-listing'], url: this.pageLocation.pathname })
        );
    },
    async processResult(store, result, block) {
        const sort = [];
        let outsideFields = [];
        const location = {
            customizedCity: result.customizedCity
        };
        const searchData = result.configs || [];
        //  Middle platform ，priceKeys Collect all price related fields , need to be converted into US dollars consition backend
        let priceKeys = [];
        searchData.forEach((config, index) => {
            let { conditions, name } = config;
            if (store.listingSource === 'rental listings' && config.id === 2) { // Basic Info
                conditions = conditions.filter(it => it.name !== 'purchaseType')
                searchData[index].conditions = conditions
            }
            if (this.platform.isMobile && this.theme === 'layout1') {
                outsideFields = []
            } else if (name === 'Basic Info') {
                let temp = conditions.slice(0, 5).map(o => o.name.toLowerCase())
                if (temp.includes('location')) {
                    outsideFields = temp.filter(o => o !== 'location');
                } else {
                    outsideFields = temp.slice(0, 4);
                }
            }
            conditions.forEach(o => {
                if (o.mask && o.mask.mask === 'money') {
                    priceKeys.push(o.name.toLowerCase());
                }
                o.initName = o.name; // 驼峰
                const name = (o.name = o.name.toLowerCase());
                sort.push(name);
                if (name === 'location') {
                    location.condition = o;
                    location.isExactSearch = !o.freeInput;
                    location.placeholder =
                        result.locationPlaceholder &&
                        result.locationPlaceholder
                            .map(({ name, nameText }) => nameText || name)
                            .filter(Boolean)
                            .join(', ');
                }
            });
        });
        store[TYPES.CENTER_SET_SEARCH_CONFIG_MAP]({
            fetcherData: {
                location,
                rawConf: searchData
            },
            conditionSort: sort
        });
        store[TYPES.CURRENCY_PRICE_KEYS](priceKeys);
        store[TYPES.SET_OUT_SIDE_FIELDS](outsideFields);
        await searchCenter.normalizeUrlParams.call(this, store, block);
    },
    // getUrlConditions(queryPrams){
    //     let {condition = {}, presetParams = {}} = queryPrams;
    //     if(typeof condition === 'string'){
    //         condition = util.parseJSON(condition)
    //     } 
    //     if(typeof presetParams === 'string'){
    //         presetParams = util.parseJSON(presetParams)
    //     } 
    //     return Object.assign({}, presetParams, condition)
    // },
    async normalizeUrlParams(store, block) {
        let { page: globalData, forCMS } = usePageStore(this.$pinia);
        let query = getQueryWithDecodeKey(globalData);
        if (query.uiConfig) {
            let uiConfig = query.uiConfig || {};
            if (typeof uiConfig === 'string') {
                uiConfig = util.parseJSON(uiConfig);
            }
            store[TYPES.CENTER_SET_UI_CONFIG](uiConfig || {});
            if (!util.isSSRServer && window.parent && forCMS) {
                window.parent.postMessage(
                    {
                        action: 'update_ui_config',
                        data: JSON.parse(JSON.stringify(uiConfig)) || {}
                    },
                    '*'
                );
            }
            delete query.uiConfig;
        }
        if (query.presetParams) {
            store[TYPES.CENTER_URL_PRESET_PARAMS](                
                util.parseJSON(query.presetParams)
            );
            // this.urlPresetParams = util.parseJSON(query.presetParams);
            delete query.presetParams;
        }
        query = searchCenter.setConditionOnUrl.call(this, store, query, block);
        delete query['chime-format'];
        delete query['global_domain'];
        store[OTHER_URL_QUERY_MUTATION](query);
        await searchCenter.initPresetParams.call(this, store);
    },
    noUsePresetFilter(store) {
        let flag = false;
        if (searchCenter.isCustomListing.call(this, store)) {
            flag = true;
        } else {
            flag =
                Object.keys(store.urlPresetParams || {}).length > 0 ||
                Object.keys(store.conditionOnUrl || {}).length > 0;
        }
        return flag;
    },
    handleLocation(store, condition = {}) {
        const { location = {} } = condition;
        if (!location.mapPath && !location.mapRadius && !location.mapSearch) {
            Object.entries(location).forEach(([type, value]) => {
                if (Array.isArray(value)) {
                    value.forEach(o => {
                        store[ADD_KEYWORD_MUTATION]({
                            keyword: o,
                            keywordType: type
                        });
                    });
                } else {
                    console.warn("handleLocation  Invalid value :", value)
                }

            });
        } else {
            let mapPath = location.mapPath;
            let mapSearch = location.mapSearch;
            let mapRadius = location.mapRadius;
            // mapPath  There are two formats
            // String  exist presetFilter middle
            // Array<String>  exist URL middle
            mapPath = Array.isArray(mapPath)
                ? JSON.stringify(mapPath.map(o => util.parseJSON(o)))
                : mapPath;
            store[MAP_CHANGE_MUTATION]({
                mapPath: mapPath || null,
                mapSearch:
                        !!eval(mapSearch) ||
                        !!eval(condition.mapSearch),
                rect: location.rect || null,
                mapRadius
            });
        }
        delete condition.location;
        return condition;
    },
    processSqft(store, condition = {}) {
        Object.keys(condition).forEach(key => {
            const ui = store.uiConfig[key];
            const { sqft } = ui || {};
            if (sqft === 'acre' && condition[key]) {
                const [v1, v2] = condition[key].split(',');
                condition[key] = `${sqftToAcre(v1)},${sqftToAcre(v2)}`;
            }
        });
        return condition;
    },
    async initPresetParams(store) {
        let computedCondition = searchCenter.mergeCondition.call(this, store);
        computedCondition = searchCenter.handleLocation.call(this, store, computedCondition);
        computedCondition = searchCenter.processSqft.call(this, store, computedCondition);
        //fix:SITE-15755  all preconditions key Lowercase
        for (let key in computedCondition) {
            if (/[A-Z]/g.test(key)) {
                computedCondition[key.toLowerCase()] = computedCondition[key];
                delete computedCondition[key];
            }
        }
        searchCenter.getSelectOptionsWithPresetParams.call(this, store, computedCondition);
        store[TYPES.CENTER_COMPUTED_PRESET_FILTER](computedCondition);
        await store[TYPES.CENTER_COMMIT_CONDITION]();

    },
    getSelectOptionsWithPresetParams(store, computedCondition) {
        let { siteId } = usePageStore(this.$pinia);
        let searchData = store.fetcherData?.rawConf;
        searchData.forEach(config => {
            const { conditions } = config;
            conditions.forEach(o => {
                if (
                    o.inputType === 'multiSelect' ||
                    o.inputType === 'singleSelect'
                ) {
                    o.options = [];
                    if (computedCondition) {
                        const curValue = computedCondition[o.name.toLowerCase()];
                        if (curValue) {
                            searchCenter.setItemOptions.call(this, o, siteId); // 用来回显url里面的搜索条件,需要先获取对应的options
                        }
                    }
                }
            })
        })
    },
    setItemOptions(o, siteId) {
        fetchFilterItemOptions.call(this, {
            siteId,
            type: o.name
        }).then(data => {
            o.options = data || [];
        });
    },
    mergeCondition(store) {
        let { page: globalData, forCMS } = usePageStore(this.$pinia);
        let params = null;
        const listingIds = getListingIds(this.pageLocation);
        if (
            searchCenter.noUsePresetFilter.call(this, store) ||
            listingIds ||
            isCustomListingSource(globalData.URI_REQUEST_PARAMS?.listingSource)
        ) {
            //  no default or listingIds url parameter ， then apply url parameter
            params = store.urlPresetParams || store.conditionOnUrl || {};
        } else {
            //  Use the default
            params = this.presetFiltersV2;
            store[TYPES.CENTER_SET_UI_CONFIG](this.uiConfig);
            if (!util.isSSRServer && window.parent && forCMS) {
                window.parent.postMessage(
                    {
                        action: 'update_ui_config',
                        data: JSON.parse(JSON.stringify(store.uiConfig)) || {}
                    },
                    '*'
                );
            }
        }
        params = Object.assign({}, params);
        try {
            let { query = {} } = this.pageLocation || {};
            let mapSearch = eval(query.mapSearch);
            if (mapSearch) {
                params.location = {};
                params.location.mapSearch = mapSearch;
            }
        } catch (error) {
            console.error(error);
        }
        if (listingIds) {
            store[SET_LISTING_IDS](listingIds);
        }
        return params;
    },
    lowerCaseName(condition) {
        return Object.keys(condition).reduce((memo, name) => {
            memo[name.toLowerCase()] = condition[name];
            return memo;
        }, {});
    },
    setConditionOnUrl(store, query, block) {
        let { condition } = query;
        if (typeof condition === 'string') {
            condition = util.parseJSON(condition);
        }
        condition = condition || {};
        if (condition) {
            condition = searchCenter.lowerCaseName(condition);
            if (block === 'snapshot') {
                condition.listingstatus && delete condition.listingstatus;
            }
            if (this.hideSearch && condition.listingstatus) {
                // snapshot delete  listing status
                //  TODO
                delete condition.listingstatus;
            }
            store[TYPES.CENTER_CONDITION_ON_URL](condition);
        }
        delete query.condition;
        return query;
    }
};

export function getListingSource(store, {
    query,
    listingSource: listingSourceOut
}) {
    let listingSourceReady = store.listingSourceReady;
    return new Promise((resolve, reject) => {
        if (listingSourceReady) {
            return resolve();
        }
        // snapshot middle listing source for sold listing
        if (listingSourceOut) {
            setListingSource.call(this, store, listingSourceOut);
            resolve();
        }
        let listingSource =
            query.listingSource || query.featureListingName || '';
        if (listingSource) {
            let reg = /^\d\+/;
            if (
                reg.test(listingSource) ||
                [
                    'all listings',
                    'sold listings',
                    'rental listings',
                    'only my listings',
                    'only team listings',
                    'single property promotion'
                ].indexOf(listingSource.toLowerCase()) !== -1
            ) {
                setListingSource.call(this, store, listingSource);
                resolve();
            } else {
                return getFilterType.call(this, {
                    name: listingSource
                }).then(data => {
                    if (data) {
                        setListingSource.call(this, store, `${data.listingType}+${listingSource}`);
                    }
                    resolve();
                })
                    .catch(err => {
                        reject(err);
                    });
            }
        } else {
            setListingSource.call(this, store, this.listingSource);
            resolve();
        }
    });
}

export async function init(store, block) {
    let { page: globalData } = usePageStore(this.$pinia);
    const siteId = globalData.siteId;
    const isSearchCenter = globalData.searchCenter;
    const listingType = store.listingType;
    const params = {
        siteId: siteId,
        isSold: listingType === 'sold-listing',
        showMore: true
    };
    let ret;
    if (isSearchCenter) {
        ret = await fetchCenterAllConditions.call(this, {
            siteId,
            isSold: listingType === 'sold-listing'
        });
    } else {
        ret = await fetchSearchConf.call(this, params);
    }
    if (isSearchCenter) {
        await searchCenter.processResult.call(this, store, ret || {}, block);
    } else {
        await search.processResult.call(this, store, ret || {});
    }
    store[SET_SEARCH_DATA_READY](true);
    this.blockOb?.dispatch(SET_SEARCH_DATA_READY, {
        name: this.mdData.name, 
        searchParams: store.searchParamsWithMap
    });
}

export const getDftSuggestion = function(store) {
    return getDefaultSuggestion.call(this).then(res => {
        const {
            searchCharts,
            customizedCity,
            locationPlaceholder
        } = res || {};
        if (customizedCity) {
            store[TYPES.SET_CUSTOMIZED_CITY](customizedCity);
        }
        if (searchCharts) {
            store[TYPES.SET_SEARCH_CHARTS](searchCharts);
        }
        if (locationPlaceholder) {
            store[TYPES.SET_LOCATION_PLACEHOLDER](
                locationPlaceholder
                    .map(({ name, nameText }) => nameText || name)
                    .filter(Boolean)
                    .join(', ')
            )
        }
    });
}

export function asyncData(store, { listingSource = '', block = '' } = {}) {
    let { page: globalData } = usePageStore(this.$pinia);
    let query = getQueryWithDecodeKey(globalData);
    return getListingSource
        .call(this, store, {
            query,
            listingSource
        })
        .then(() => {
            return Promise.all([
                // getDftSuggestion.call(this, store),
                init.call(this, store, block)
            ]);
        });
}
